export const FETCHING_DEBOUNCE = 500;
export const DEFAULT_MAX_TAGS = 3;
export const DEFAULT_LOCALE = 'en-us';
export const UNHIGHLIGHT_REGEXP = /<[/]{0,}strong>/g;
export const ADD_TAGS_KEYCODES = [
    13, // Enter
    9, // Tab
    188, // Comma
];
export const FETCHING_INDUSTRIES_PREFIX_KEY = 'industies';
export const FETCHING_AUTOCOMPLETE_KEY = 'autocomplete';
